import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectShownPage = createSelector(
  (state: GlobalState) => state.shownPage,
  (page) => page,
);
